/* Pawmute storefront behaviour: scroll reveals, FAQ accordion,
   sticky buy dock, and the bundle selector that drives the real
   Shopify product form. No dependencies. */
(function () {
  'use strict';

  /* ---------- scroll reveals ---------- */
  function reveals() {
    var els = [].slice.call(document.querySelectorAll('.hp .rv:not(.in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var sibs = [].slice.call(en.target.parentNode.children).filter(function (n) {
          return n.classList.contains('rv');
        });
        en.target.style.transitionDelay = (Math.min(sibs.indexOf(en.target), 5) * 80) + 'ms';
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- FAQ accordion ---------- */
  function faq(root) {
    var items = [].slice.call(root.querySelectorAll('.faq-item'));
    if (!items.length) return;
    function setH(item, open) {
      var a = item.querySelector('.faq-a');
      a.style.height = open ? a.firstElementChild.offsetHeight + 'px' : '0px';
    }
    items.forEach(function (item) {
      var btn = item.querySelector('.faq-q');
      setH(item, item.dataset.open === 'true');
      btn.addEventListener('click', function () {
        var open = item.dataset.open !== 'true';
        items.forEach(function (o) {
          o.dataset.open = 'false';
          o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
          setH(o, false);
        });
        if (open) {
          item.dataset.open = 'true';
          btn.setAttribute('aria-expanded', 'true');
          setH(item, true);
        }
      });
    });
    window.addEventListener('resize', function () {
      items.forEach(function (o) { setH(o, o.dataset.open === 'true'); });
    });
  }

  /* ---------- sticky buy dock ---------- */
  function dock(root) {
    var d = root.querySelector('.dock');
    // Watch the real Add to cart button, not the whole hero. The hero is taller
    // than a phone screen, so watching it kept the sticky bar hidden for the
    // entire first two screens.
    var anchor = root.querySelector('.hero-cta .btn-primary') || root.querySelector('.hero');
    if (!d || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      d.classList.toggle('show', !en[0].isIntersecting);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- bundle selector -> real product form ---------- */
  function bundles(root) {
    var form = root.querySelector('.hp-buy-form');
    if (!form) return;
    var radios = [].slice.call(form.querySelectorAll('input[name="id"]'));
    if (!radios.length) return;

    function outs(sel) { return [].slice.call(root.querySelectorAll(sel)); }

    function sync() {
      var checked = form.querySelector('input[name="id"]:checked');
      if (!checked) return;
      var card = checked.closest('.bundle');
      if (!card) return;
      var d = card.dataset;

      outs('[data-price-out]').forEach(function (n) { n.textContent = d.price; });
      outs('[data-was-out]').forEach(function (n) {
        n.textContent = d.was || '';
        n.hidden = !d.was;
      });
      outs('[data-save-out]').forEach(function (n) {
        n.textContent = d.save ? 'Save ' + d.save : '';
        n.hidden = !d.save;
      });
      outs('[data-cta-label]').forEach(function (n) {
        n.textContent = (n.dataset.ctaLabel || 'Add to cart') + ' — ' + d.price;
      });
      outs('[data-soldout-toggle]').forEach(function (n) {
        n.hidden = d.available === 'true';
      });
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = d.available !== 'true';
    }

    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();

    /* the mobile dock button submits the same real product form */
    outs('[data-dock-submit]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
    });
  }

  function init() {
    reveals();
    [].slice.call(document.querySelectorAll('.hp')).forEach(function (root) {
      if (root.dataset.hpInit === '1') return;
      root.dataset.hpInit = '1';
      faq(root);
      dock(root);
      bundles(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* re-run after Theme Editor re-renders a section */
  document.addEventListener('shopify:section:load', init);
})();
